export enum InspectionImageType {
    DEFECT = 'D',
    FULL_PRODUCT = 'FP',
    VERIFICATION = 'V'
}